<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="800">
    <template v-slot:title>{{ editorTitle }}</template>
    <v-row
      ><v-col
        ><v-text-field
          v-model="name"
          label="Task Status"
          :outlined="outlinedInputs"
        ></v-text-field></v-col
    ></v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <v-row v-if="debug">
      <v-col
        ><code>{{ value }}</code></v-col
      >
    </v-row>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";

export default {
  name: "task-status-edit-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: { BasicDialog },

  data() {
    return {
      debug: false,
      name: this.value ? this.value.name : "New Task Status",
    };
  },

  computed: {
    editorTitle() {
      return `${this.value && this.value.id ? "Edit" : "Add"} - ${this.name}`;
    },
    isValid() {
      return this.name && this.name != "";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newVal) {
      this.name = newVal ? newVal.name : "New Task Status";
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        id: this.value && this.value.id ? this.value.id : undefined,
        name: this.name,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/tasks/TaskStatusEditDialog.vue